import { Grid, Typography, makeStyles, Button, List, ListItem, IconButton, ListItemIcon, Divider, Dialog, Container, CardContent } from '@material-ui/core'
import PropTypes from 'prop-types'
import { Delete } from '@material-ui/icons'
import { deleteArrayIndex } from 'utils/utils'
import { Fragment, useState } from 'react'
import TaskComponent from './taskFormComponent'
import CardTitle from 'components/card/title'
import { Form } from 'react-final-form'
import { TextField, Select } from 'mui-rff'
import { OnChange } from 'react-final-form-listeners'
import { isUserInputType } from 'utils/rules'

const useStyles = makeStyles(() => ({
  main: {
    padding: '20px',
  },
  fullWidth: {
    width: '100%'
  },
  textBox: {
    paddingLeft: '15px',
  },
  selectButton: {
    margin: '5px',
    padding: ' 5px',
  },
  addButtonSmall: {
    margin: '0px',
    padding: '5px',
  }
}))
export default function TaskConditional({ component, components, save, saveFast, curIndex, type, disabled }) {
  const classes = useStyles()
  const [showDialog, setShowDialog] = useState(false)
  const [selectedRule, setSelectedRule] = useState(null)

  function saveConditional(fast) {
    let payload
    payload = { Components: components }
    if (type === 'action') payload = component
    if (fast) saveFast(payload)
    else save(payload)
  }

  if (!component.ConditionalRules) component.ConditionalRules = []
  const del = index => {
    component.ConditionalRules = deleteArrayIndex(component.ConditionalRules, index)
    saveConditional(true)
  }
  const add = () => {
    setSelectedRule(component.ConditionalRules.length)
    setShowDialog(true)
  }
  if (!component.ConditionalRules) component.ConditionalRules = []

  const taskTypeOptions = [
    {
      label: 'equal to',
      value: 'equal'
    },
    {
      label: 'any value',
      value: 'any'
    },
    {
      label: 'blank',
      value: 'blank'
    },
  ]

  return <Grid container spacing={1} className={classes.main}>
    {!disabled && <Typography className={classes.fullWidth} variant="h6">Conditional Rules</Typography>}
    {component.ConditionalRules.length === 0 ?
      <>{!disabled && <Typography className={classes.fullWidth} variant='body1'>Always {type === 'action' ? 'trigger' : ' display'}</Typography>}</>
      : <>
        <Typography className={classes.fullWidth} variant='body1'>{type === 'action' ? ' Trigger' : ' Display'} only when:</Typography>
        <List className={classes.fullWidth} dense={disabled} disablePadding={disabled}>
          {!disabled && <Divider />}
          {component.ConditionalRules.map((rule, index) => {
            const questionNumber = (typeof rule.Component !== 'undefined' || rule.ComponentID) ? 'Question #' + ((rule.ComponentID ? Object.values(components || {}).findIndex(e => e.ComponentID === rule.ComponentID) : rule.Component) + 1) : null
            return <Fragment key={index}>
              {index > 0 ? 'And' : ''}
              <ListItem key={index} disableGutters={true}>
                {!disabled ?
                  <Button variant='contained' className={classes.selectButton} onClick={() => { setSelectedRule(index); setShowDialog(true) }}>{questionNumber ?? 'Select Question'}</Button>
                  : <span style={{ marginRight: '5px' }}>{questionNumber ?? ''}</span>
                } is: <Form
                  onSubmit={() => { }}
                  initialValues={{ Value: rule.Value.join(', '), ValueType: rule.ValueType || 'equal' }}
                  subscription={{}}
                  render={() => (<>
                    <Select variant={disabled ? 'standard' : 'outlined'} disabled={disabled} name='ValueType' data={taskTypeOptions} formControlProps={{ style: { width: disabled ? 'initial' : '120px', marginLeft: '5px' } }} />
                    <OnChange name='ValueType'>{value => {
                      component.ConditionalRules[index].ValueType = value
                      saveConditional(true)
                    }}</OnChange>
                    {(component.ConditionalRules[index].ValueType === 'equal' || !component.ConditionalRules[index].ValueType) && <>
                      <TextField variant={disabled ? 'standard' : 'outlined'} disabled={disabled} name='Value' className={classes.textBox} fullWidth={false} style={{ flexGrow: 1, marginLeft: disabled ? '-34px' : 'initial' }} />
                      <OnChange name='Value'>{value => {
                        component.ConditionalRules[index].Value = value ? value.split(',').map(e => e.trim()) : ['']
                        saveConditional(false)
                      }}</OnChange>
                    </>}
                  </>)}
                />
                {!disabled && <ListItemIcon>
                  <IconButton onClick={() => del(index)}><Delete /></IconButton>
                </ListItemIcon>}</ListItem>
            </Fragment>
          })}
        </List>
        {!disabled && <p style={{ width: '100%' }}>Tip: Use commas to specify multiple values</p>}
      </>}
    <Dialog maxWidth='lg' open={showDialog} onClose={() => { setShowDialog(false) }}><ComponentChooser curIndex={curIndex} components={components} save={index => {
      if (!component.ConditionalRules[selectedRule]) component.ConditionalRules[selectedRule] = {}
      component.ConditionalRules[selectedRule].ComponentID = components?.[index]?.ComponentID ?? null
      if (!component.ConditionalRules[selectedRule].ComponentID) component.ConditionalRules[selectedRule].Component = index
      if (!component.ConditionalRules[selectedRule].Value) component.ConditionalRules[selectedRule].Value = ['']
      saveConditional(true)
      setShowDialog(false)
    }} /> </Dialog>
    {!disabled && <Button className={!type ? classes.fullWidth : classes.addButtonSmall} variant='contained' onClick={add} >Add Rule</Button>}
  </Grid>

}

export function ComponentChooser({ curIndex, components, save }) {
  return <Container>
    <CardContent>
      <CardTitle
        title='Choose Trigger Question'
        subtitle='The trigger question is checked for the trigger value.' />
      <Grid container spacing={1}>
        {Object.values(components || {}).map((c, componentIndex) => {
          if (componentIndex === curIndex) return null
          if (!isUserInputType(c) || c.Type === 'tableInput') return null
          return <Grid key={componentIndex} item xs={12}>
            <TaskComponent task={{ Components: components }} taskid={''} component={c} componentIndex={componentIndex} save={() => { }} saveFast={() => { }} selected={-1} setSelected={save} filepath='' noHoverIcons />
          </Grid>
        }).filter(e => e)}
      </Grid>
    </CardContent>
  </Container>
}

ComponentChooser.propTypes = {
  curIndex: PropTypes.number.isRequired,
  components: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  save: PropTypes.func.isRequired
}

TaskConditional.propTypes = {
  component: PropTypes.object.isRequired,
  components: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  curIndex: PropTypes.number.isRequired,
  save: PropTypes.func.isRequired,
  saveFast: PropTypes.func.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool
}